module.exports = __webpack_public_path__ + "img/coinbase.b261a251.svg";